
var jqueryDatepicker = require('jquery-datepicker');
var Chart = require('chart.js');
var myChart;

$(document).ready(function(){

	// Bind our datepicker to Jquery's $
	jqueryDatepicker($);

	function DateFields() {
		
		// Get min date from template, so can limit filter min
		var minDate = new Date( $('.line-chart canvas').attr('data-mindate'));
		
		$('.filter-from').datepicker({
			minDate: minDate,
	        changeMonth: true,
	        changeYear: true,
	        numberOfMonths: 1,
	        dateFormat: "yy-mm-dd",
	        onSelect: function(selectedDate) {
	            $(".filter-to").datepicker("option", "minDate", selectedDate);
	        },
			showOn: "button",
			buttonImage: "site/images/calendar-picker-icon.png",
			buttonImageOnly: true,
			buttonText: "Select date"
	    });

		// Get current date, to restrict max filter
		var now = new Date();
		
	    $(".filter-to").datepicker({
	        defaultDate: null,
	        changeMonth: true,
	        changeYear: true,
	        numberOfMonths: 1,
	        dateFormat: "yy-mm-dd",
			maxDate: now,
	        onSelect: function(selectedDate) {
	            $(".filter-from").datepicker("option", "maxDate", selectedDate);
	        },
			showOn: "button",
			buttonImage: "site/images/calendar-picker-icon.png",
			buttonImageOnly: true,
			buttonText: "Select date"
	    });
		
	}

	// ----------- Run initial chart
	// ------------------------------------------------------

	function InitChart() {

		var ChartElem = $(".line-chart");

		ChartElem.each(function () {
			
			// Get graph variables
			var tableID = $(this).children("canvas").attr('id');
			
			// Get all data for current graph
			// Get Data in 'dates' and 'values' arrays 
			$.ajax({
				type: "POST",
				url: window.location.pathname + "/linechartdata/" + tableID,
				success: function(data){
					
					// convert JSON to JS value
					var getData = JSON.parse(data);
					
					var ChartLabels = getData.Labels;
					var ChartValues = getData.Values;
					
					MakeChart(tableID, ChartLabels, ChartValues);				
					MakeTable(tableID, getData);
				}
			});
			

		}); // End each
	}


	// ----------- Listen for click of date-form button
	// ------------------------------------------------------
	function FilterChart() {
		
		$('.form-submit').click(function(evt) {
			evt.preventDefault();
			
			// get form
			var form = $(this).parent('form.date-filter-form');
			var datatopass = form.serialize();
			
			var tableID = $(this).closest('.line-chart').children("canvas").attr('id');

			// Get all data for current graph
			// Get Data in 'dates' and 'values' arrays 
			$.ajax({
				type: "POST",
				url: window.location.pathname + "/linechartdata/" + tableID,
				data: datatopass,
				success: function(data){
					
					// convert JSON to JS value
					var getData = JSON.parse(data);
					
					// Need to redo
					ChartLabels = getData.Labels;
					ChartValues = getData.Values;
					
					MakeChart(tableID, ChartLabels, ChartValues);
					MakeTable(tableID, getData);
				}
			});
			
		});
	}

	// make chart
	function MakeChart(tableID, ChartLabels, ChartValues) {

		if(myChart !== undefined) {
			myChart.destroy();
		}
		
		var ctx = $('#'+tableID).first();
		
		// Get graph variables
		var tableID = ctx.attr('id');
		var tableTitle = ctx.attr('data-title');
		var yAxisTitle = ctx.attr('data-yaxis');
		var xAxisTitle = ctx.attr('data-xaxis');
		var DataTypeLabel = ctx.attr('data-type');	
		
		var LabelLength = ChartLabels.length;
		if(LabelLength > 250) {
			var LabelStep = 200;
		} else if(LabelLength > 170) { 
			var LabelStep = 180;
		} else if(LabelLength > 100) {
			var LabelStep = 100;
		} else if(LabelLength > 50) {
			var LabelStep = 50;
		} else if(LabelLength > 25) {
			var LabelStep = 15;
		} else {
			var LabelStep = 9;
		}

		var data = {
			labels: ChartLabels,
			datasets: [{
				label: DataTypeLabel,
				fill: true, 
				lineTension: 0.1,
				backgroundColor: "rgba(64,166,217,0.4)",
				borderColor: "rgba(28,124,172,1)",
				borderCapStyle: 'round',  // butt, square
				pointHoverRadius: 1,
				data: ChartValues
			}]			
		};
		
		myChart = new Chart(ctx, {
			type: 'line',
			data: data,
			options: {
				title: {
					display: false,
					text: tableTitle,
					fontSize: 16,
					fontFamily: 'Arial',
					fontStyle: 'normal'
				},
				legend: {
					display: true,
					position: 'top',
					labels: {
						fontColor: 'black'
					}
				},
				scales: {
					yAxes: [{
						scaleLabel: {
							display: true,
							labelString: yAxisTitle
						}
					}],
					xAxes: [{
						scaleLabel: {
							display: true,
							labelString: xAxisTitle
						},
						type: 'time',
						time: {
							unit: 'day',
							unitStepSize: LabelStep,
							displayFormats: {
								month: 'MMM YYYY'
							}
						}
					}]
				}
			}
		});
	}

	// Make table
	function MakeTable(tableID, getData) {
		// get table
		var tableDiv = $('.line-chart canvas#' + tableID ).siblings('.table-data');
		// Append data from ajax query
		tableDiv.html('<table class="table-' + tableID + ' hidden">' + getData.Table + '</table>');
	}

	function ToggleDataViews() {
		
		$('.line-chart header .icons .icon').click(function() {
			
			var chartElem = $(this).closest('.line-chart');
			
			// Remove all active classes and apply to clicked
			$(this).siblings('.icon').removeClass('active');
			$(this).addClass('active');
			
			// Hide all graph/charts
			chartElem.children('.graph-type').addClass('hidden');
			
			// Show clicked type
			var type = $(this).attr('data-graph');	
			chartElem.children('.graph-type.' + type).removeClass('hidden');
			
		});
		
	}
	
	// On load
	DateFields();
	InitChart();
	FilterChart();
	ToggleDataViews();	
});